import {
  CircularProgress as MaterialCircularProgress,
  CircularProgressProps,
} from "@rmwc/circular-progress";
import * as React from "react";
// tslint:disable-next-line
require("@rmwc/circular-progress/circular-progress.css");

export type CircularProgressSize =
  | "xsmall"
  | "small"
  | "medium"
  | "large"
  | "xlarge";
interface CustomProps {
  className?: string;
  progress?: number;
  size?: CircularProgressSize;
  style?: React.CSSProperties;
}

type Props = Pick<CircularProgressProps, "size"> & CustomProps;

export const CircularProgress: React.FC<Props> = props => {
  const { className, progress, size, style } = props;

  return (
    <MaterialCircularProgress
      className={className}
      progress={progress}
      size={size}
      style={style}
    />
  );
};
